import { StarIcon } from '@heroicons/react/24/outline';
import { useTranslations } from 'next-intl';
import { Dispatch, SetStateAction } from 'react';

import Button from '../UI/Button';
import Modal from './Modal';

interface ValidateEmailModalProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  email: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ValidateEmailModal({
  open,
  setOpen,
  email,
  onConfirm,
  onCancel,
}: ValidateEmailModalProps) {
  const t = useTranslations('Components.Modal.ValidateEmailModal');

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      closeButton={false}
      panelClassName='backdrop-filter backdrop-blur-lg bg-[#101114]/[90]'
      padding='px-4 pb-10 mb-20'
    >
      <div className='relative'>
        <div className='pt-10'>
          <div className='isolate mx-auto flex size-14 items-center justify-center rounded-full bg-primary-filled-default'>
            <div className='absolute size-11 animate-ping-slow rounded-full bg-primary-filled-default' />
            <div className='absolute size-14 animate-ping-slow rounded-full bg-primary-filled-default' />
            <div className='absolute size-64 blur-2xl rounded-full bg-primary-filled-default bg-primary-filled-default/[0.12]' />
            <StarIcon className='relative z-10 h-6 w-6' />
          </div>
        </div>
        <div className='pb-5 text-center'>
          <p className='pb-5 pt-10 text-xl font-bold'>
            {t('confirmEmailAddress')}
          </p>
          <p>{t('is')}</p>
          <p className='truncate text-lg font-bold'>{email}</p>
          <p>{t('yourmailAddress')}</p>
        </div>
        <div className='flex justify-center pb-5 pt-3'>
          <Button padding='xl' onClick={onConfirm} id='validateEmail'>
            {t('yes')}
          </Button>
        </div>
        <div className='flex justify-center'>
          <Button variant='link' onClick={onCancel}>
            {t('change')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
